import {styled} from '@mui/material';

export const FormActions = styled('div')(({theme}) => ({
  display: 'flex',
  '.MuiButton-root': {
    marginRight: theme.spacing(1),
  },
}));
